import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

export interface LoaderStep {
  label: string
  params?: Record<string, any>
  debugOnly: boolean
}

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  step$ = new BehaviorSubject<LoaderStep | undefined>(undefined)

  setStep(label: string, params?: Record<string, any>): void {
    this.step$.next({ label, params, debugOnly: false })
  }

  setDebugStep(label: string): void {
    this.step$.next({ label, debugOnly: true })
  }

  clearStep(): void {
    this.step$.next(undefined)
  }
}
